import { RefObject } from 'preact/compat';

import { ComponentMessageContainer, ComponentMessageItem } from '../UNSAFE_ComponentMessage';
import { useFormFieldContext } from '../hooks/UNSAFE_useFormFieldContext';
import { Popup } from '../UNSAFE_Popup';
import { Coords } from '../UNSAFE_Floating';
import { Divider } from '../UNSAFE_Divider';
import { usePopupFocusWithin } from './usePopupFocusWithin';
import { assistiveStyles, dividerStyle } from './themes/UserAssistanceStyles.css';
import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { UserAssistanceRedwoodTheme } from './themes/redwood/UserAssistanceTheme';

type Props = {
  anchorRef: RefObject<HTMLElement | Coords>;
  assistiveText?: string;
  fieldLabel?: string;
  id?: string;
  messages?: ComponentMessageItem[];
};

export function CompactUserAssistance({
  anchorRef,
  assistiveText,
  fieldLabel,
  id,
  messages = []
}: Props) {
  const { isInputFocused, isReadonly } = useFormFieldContext();
  const flip = { mainAxis: true, crossAxis: false };
  const { isFocused: isPopupFocused, popupProps } = usePopupFocusWithin();
  const isOpen = isInputFocused === true || isPopupFocused === true;

  const { baseTheme } = useComponentTheme(UserAssistanceRedwoodTheme);

  const uaCompactContent =
    isReadonly !== true && (messages.length > 0 || assistiveText) ? (
      <Popup
        {...popupProps}
        placement="end-top-corner"
        isOpen={isOpen}
        anchorRef={anchorRef}
        flipOptions={flip}
        tail="simple">
        <div id={id} class={baseTheme}>
          {messages.length > 0 && (
            <ComponentMessageContainer fieldLabel={fieldLabel} messages={messages} />
          )}
          {messages.length > 0 && assistiveText && (
            <span class={dividerStyle}>
              <Divider />
            </span>
          )}
          {assistiveText && <span class={assistiveStyles}>{assistiveText}</span>}
        </div>
      </Popup>
    ) : null;

  return uaCompactContent;
}
